{
  "app" : {
    "title": "YOUTINE | App"
  },
  "router" : {
    "basePath" : "/"
  }
}
